const salas = [
  {
    id: 1,
    name: "Sala 1: Espacio Creativo",
    description:
      "Una sala amplia y completamente equipada, perfecta para grandes eventos y actividades de circo. Cuenta con equipo de sonido, baño, duchas y piso de losa radiante, ideal para mantener el confort en los días fríos. Capacidad para hasta 300 personas.",
    images: [
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737761159/La%20Troupe/sala1_o7ahpf.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737762068/La%20Troupe/sala1_1_a9nbns.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737762069/La%20Troupe/sala1_2_ivtrhl.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737762069/La%20Troupe/sala1_3_ib4gth.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737762070/La%20Troupe/sala1_4_wwmehx.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737762071/La%20Troupe/sala1_5_zlmrqz.jpg"
    ],    
  },
  {
    id: 2,
    name: "Sala 2: Espacio de Alta Energía",
    description:
      "Un espacio vibrante y versátil, perfecto para grupos grandes, talleres creativos y entrenamientos intensivos. Totalmente equipado para el mundo del circo, con baños, duchas y un sistema de sonido profesional. Además, cuenta con iluminación de fiesta, ideal para eventos.",
    images: [
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737761159/La%20Troupe/sala2_jxcbbe.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737761845/La%20Troupe/sala2_1_tdbvb1.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737761845/La%20Troupe/sala2_2_j7ywqg.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737761846/La%20Troupe/sala2_3_sllq1l.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737761847/La%20Troupe/sala2_4_t8b6gv.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737762072/La%20Troupe/sala2_5_lwswcf.jpg"
    ],
  },
  {
    id: 3,
    name: "Sala 3: Espacio Versátil",
    description:
      "Un espacio amplio y versátil, diseñado para ensayos de circo, danza y teatro. Cuenta con un gran espejo, barra de apoyo, equipo de sonido y telones que permiten ajustar la iluminación para un ambiente más íntimo.",
    images: [
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737761159/La%20Troupe/sala3_prevzj.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737761474/La%20Troupe/sala3_1_ecboij.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737761474/La%20Troupe/sala3_2_xl1fdr.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737761474/La%20Troupe/sala3_3_ncmae3.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737761475/La%20Troupe/sala3_4_tzakv5.jpg",
      "https://res.cloudinary.com/dkdhdy9e5/image/upload/v1737761475/La%20Troupe/sala3_5_pcko3d.jpg"
    ],
  },
];

export default salas;
